// extracted by mini-css-extract-plugin
export default {"header":"style_header__Ijc9s","title":"style_title__KiK+p","subtitle":"style_subtitle__vlbb9","subtitleCentral":"style_subtitleCentral__1aczk"};